import {makeAutoObservable} from 'mobx';
import {auth} from "../utils/firebase";

export class PluginState {
    rootStore;
    linkedInPluginInstalled = "Need to Install plugin";
    isInstalledTimeOut = null;

    constructor(rootStore) {
        this.rootStore = rootStore;
        makeAutoObservable(this);
        this.isInstalledTimeOut = setTimeout(this.initGetPluginInstalled.bind(this), 1000, "PluginState.constructor");
    }

    setPluginInstalled(value, caller){
        if (value) {
            this.linkedInPluginInstalled = "Plugin Is Installed";
        } else {
            this.linkedInPluginInstalled = "Need to Install plugin";
        }
        this.resetTimeOut(" PluginState.setPluginInstalled()");
    }

    resetTimeOut(caller){
        clearTimeout(this.isInstalledTimeOut);
        this.isInstalledTimeOut = setTimeout(this.initGetPluginInstalled.bind(this), 5000, " PluginState.resetTimeOut()");
    }

    initGetPluginInstalled(caller){
        window.postMessage({
            type: 'lc_get_is_clicker_installed'
        }, '*');
    }

    postAuthTokenToExtension(token) {
        if (!token) {
            return;
        }
        window.postMessage({
            type: 'lc_set_auth_token',
            result: token
        }, '*');
    }

    clearAuthTokenInExtension() {
        window.postMessage({
            type: 'lc_clear_auth_token'
        }, '*');
    }

    async syncCurrentUserTokenToExtension(caller) {
        if (auth != null && auth.currentUser !== null) {
            const token = await auth.currentUser.getIdToken(false);
            this.postAuthTokenToExtension(token);
        }
    }
}
